import { render } from "./StartSection.vue?vue&type=template&id=69ff267c&ts=true"
import script from "./StartSection.vue?vue&type=script&lang=ts"
export * from "./StartSection.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__